module.exports = "<p>\n  test3 works!\n</p>\n"